module.exports = __webpack_public_path__ + "img/2.b95bb062.png";